import { useState } from "react";

import { useAppSelector } from "../../../app/hooks";

import EmptyRecommendationState from "./EmptyRecommendationState";

import FraudElementContent from "./FraudElementContent";

import FraudElementsOverview from "./FraudElementsOverview";
import { selectPartiesWithSCNAction } from "../../recommendations/logic/ActionsAgainstPerpetratorsSlice";

export default function FraudElementsView() {
  const scnParties = useAppSelector(selectPartiesWithSCNAction);

  const [selectedPartyId, setSelectedPartyId] = useState< string | undefined>();

  if (scnParties.length === 0) {
    return <EmptyRecommendationState />;
  }

  return (
    <>
      <FraudElementsOverview
        selectedPartyId={selectedPartyId}
        onPartyChange={setSelectedPartyId}
      />

      <div className="min-h-0 flex-1">
        <FraudElementContent
          selectedPartyId={selectedPartyId}
        />
      </div>
    </>
  );
}